/*
 * Purpose : Common component for Back Button
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React from 'react'
import {Button, FormGroup} from "reactstrap";
import {IoMdArrowRoundBack} from "react-icons/io";
import {NavLink} from 'react-router-dom'

import './BackButton.css';

const BackButton = (props) => {
    return (
        // <div className={"backBtnDiv"}>
            <FormGroup>
                <NavLink style={{ textDecoration: 'none' }} to={props.path} exact>
                    <Button className={"backBtn"}>
                        <IoMdArrowRoundBack style={{ fontSize: "20px"}}/>&nbsp;&nbsp;{props.label}
                    </Button>
                </NavLink>
            </FormGroup>    
        // </div>
        
    )
}

export default BackButton
